// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CalculateTotal, chain } from "@insite/client-framework/Store/Pages/QuickOrder/Handlers/CalculateTotal";

export const xCalculateTotal: typeof CalculateTotal = props => {
    let total = 0;
    props.getState().pages.quickOrder.productInfos.forEach(o => {
        const qtyOnHand = o?.inventory?.qtyOnHand;
        const extendedUnitNetPrice = o?.pricing?.extendedUnitNetPrice;
        total += qtyOnHand && extendedUnitNetPrice ? extendedUnitNetPrice : 0;
    });
    props.result = total;
};

replaceInChain(chain, CalculateTotal, xCalculateTotal);
